// Professional stock photography (Unsplash, free commercial license) mapped per service.
const U = (id, q = "photo") => `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200`;

export const SERVICE_IMAGES = {
  service_ppf: U("photo-1708805282676-0c15476eb8a2"),
  service_wrap: U("photo-1652987086612-d948b775d358"),
  service_tint: U("photo-1698533189222-f53e9f4193b9"),
  service_color_change: U("photo-1632605166776-7128669886e7"),
  service_ceramic: U("photo-1708805282706-f44730b7e527"),
  service_paint_correction: U("photo-1708805282695-ef186db20192"),
  service_carplay: U("photo-1648892936786-de40bb1080a6"),
  service_navigation: U("photo-1787750569966-b640cbd8f4e7"),
  service_multimedia: U("photo-1684014450269-87cb2823a959"),
  service_coding: U("photo-1636935529049-2078e9ee3e6c"),
  service_bodykit: U("photo-1596125099792-3917bf2d8095"),
  service_tuning: U("photo-1698533188503-49210217aaa2"),
};

export const HERO_IMG = U("photo-1596125099792-3917bf2d8095");

// AI-generated, service-specific images for the Hizmetlerimiz section.
const P = (h) => `https://static.prod-images.emergentagent.com/jobs/cb03ebed-9561-4bb8-9038-3fc39ca34f62/images/${h}.jpeg`;
export const SERVICE_AI = {
  service_ppf: P("0171919f3b2311981d3b91784e556adbc69cc10462bea2651a4ae814e1ab7f70"),
  service_wrap: P("5de68a4c3a3aa17c3546b47178c9839710c443ee2adb7920b717b42592604320"),
  service_tint: P("c162af7fb115d907be04b9fe638498f9821380fe1e069e6cc15a919428a2c4ab"),
  service_color_change: P("02bdb7d6c641321cb356529fbf8c274baed26e2cc3a6d1d624490cec5abd0a53"),
  service_ceramic: P("1e3120664a93b456cd3269feda0fe271327ed5e76a43042157b8d2a5eebed4d4"),
  service_paint_correction: P("47b2bade9ef8face3c324e6a9b4c65264ec823951bb4dc7e6f3f312cb91092a5"),
  service_carplay: P("334f0188dcc36d0d5fae614a1dc651ac0f361bcdedb7d382c616568d96151588"),
  service_navigation: P("41634bb1cd294f9e8c11d9a557e19a5011d4fcf2cf0f8067470dace450138497"),
  service_multimedia: P("f84cacbe2658b11db27dc99068fb40aae909527adf9e1980d449847256193901"),
  service_coding: P("39939b7b46d23f68a3876f7b97183bd87a4925251e29cb9b41cae30c66841619"),
  service_bodykit: P("bf0d88c79eed1dc7befac0c20c61112b5f403b47908537f0d35aa1e675d4761f"),
  service_tuning: P("6b805b5d5915351f422b93082e8457fce0cac3f32daa38806fd4571096e8e0ff"),
};
export const serviceAi = (id) => SERVICE_AI[id] || HERO_IMG;

// Second unique AI image per service (used for the right-side card).
export const SERVICE_AI2 = {
  service_ppf: P("68816eecd351c5f02d99fdb255e8d21371e8e8058b3de7ef0b35d8cbced0e5ac"),
  service_wrap: P("ce65fde4aaa2eb5f299e5be05b9690a28b50b622e2f5485385b54ca5c9e63752"),
  service_tint: P("0d59a98cd63f3a967399bbde37221c9c94ee7f2cf29f7da8b8de65f75902f066"),
  service_color_change: P("d6d085e3d202a88442202bebabd73c5841594074414e248224bd6436f6c117c5"),
  service_ceramic: P("9b19a2950c2c706970fff23ffc8da8c5654803fa639b75a51156b44c868b3a0f"),
  service_paint_correction: P("92202dffda2928301f4789890ca1fa5d38fd70a22fe1dc061582c5982cafb206"),
  service_carplay: P("0e7aba8fb80bd5d59d0d53cdaccfe7b294f1d905f15add9b362f14a1c368acd4"),
  service_navigation: P("baf0bb69ac22b4b5ca4762b9525f77b3f31354ed115e86a0aa7fa19b67323a2d"),
  service_multimedia: P("a82a622f8e6017705612a421f1992427668cb1b5730f4de3545bf96e70fe36b5"),
  service_coding: P("c33d4438958d286b92d62c866e4383167f6b8dc1674fe9ce95e09d72e163d8e5"),
  service_bodykit: P("fe45a2cfe0e6f025e621b81726c4b1e4c9d81a8c0bb7f907b71591ad3c390b62"),
  service_tuning: P("f15804a5a89ae761ab4ffd9324cfe514b2cfd5e6a8dd2b1dd308ad6bc3041dac"),
};
export const serviceAi2 = (id) => SERVICE_AI2[id] || SERVICE_AI[id] || HERO_IMG;

const ASSET = "https://customer-assets-7cd3h4nn.emergentagent.net/job_auto-tuning-stage-1/artifacts";

// Real client project photos.
export const GALLERY = [
  `${ASSET}/z41fqjmc_1.jpg`,
  `${ASSET}/onuqutas_2.jpg`,
  `${ASSET}/1bo2n1qg_3.jpg`,
  `${ASSET}/ujhysc9d_4.jpg`,
  `${ASSET}/99pk27ls_5.jpg`,
  `${ASSET}/gtg9gtts_6.jpg`,
  `${ASSET}/voyzceak_7.jpg`,
  `${ASSET}/i8pvsj5x_8.jpg`,
  `${ASSET}/p6n3tbn2_9.jpg`,
  `${ASSET}/q5kt3suq_10.jpg`,
  `${ASSET}/17lvgskh_11.jpg`,
  `${ASSET}/91qrbqb0_12.jpg`,
  `${ASSET}/752zn075_13.jpg`,
  `${ASSET}/xs1gdh96_14.jpg`,
  `${ASSET}/is7qy1l6_15.jpg`,
];

export const GALLERY_LABEL = { tr: "Galeri", en: "Gallery", el: "Γκαλερί", ru: "Галерея", fa: "گالری" };
export const serviceImg = (id) => SERVICE_IMAGES[id] || HERO_IMG;
